module.exports = __webpack_public_path__ + "img/installation-script.bea549e5.png";